import fp from 'lodash/fp';
import connect from 'react-redux/lib/connect/connect';
import { compose, withProps } from 'recompose';
import { routes } from '../../../../constants';
import { default as Home } from './home';

const technicalCpdCategoryFilter = ({ industryCpdCategorys }) => ({ cpdCategoryId, ...aoa }) => {
  const childCpdCategory = fp.filter(({ parentCpdCategoryId }) => parentCpdCategoryId)(industryCpdCategorys)
  return {
    ...aoa,
    cpdCategoryId,
    hide: !fp.find(
      ({ id }) => id === cpdCategoryId
    )(childCpdCategory) && aoa.title !== 'Technical Competence',
    isChildCpdCategory: fp.find(({ id }) => id === cpdCategoryId)(childCpdCategory)
  }
}

const mapTechnicalCpdProgress = ({
  cpdProgress: {
    primaryStat,
    derivedStat,
    children
  }
}) => ({
  cpdCategory: 'Technical Competence',
  totalCpdCategorys: children.length,
  ...primaryStat,
  ...derivedStat
})

const selectTechnicalCpdProgress = (state) => {
  const technicalId = fp.flow(
    fp.find(
      ({ name }) => name === 'Technical Competence'
    ),
    fp.get('id')
  )(state.cpdCategorys.cpdCategorys)
  const industryCpdCategory = state.industry.cpdCategorys
  return {
    cpdCategorys: fp.filter(
      ({ parentCpdCategoryId }) => parentCpdCategoryId === technicalId
    )(industryCpdCategory),
    cpdProgress: fp.flow(
      fp.get('cpdCategoryProgress.cpdCategorys'),
      fp.find(
        ({ cpdCategoryId }) => cpdCategoryId === technicalId
      )
    )(state.user)
  }
}

const mapStateToProps = (state) => ({
  technicalCpdProgress: selectTechnicalCpdProgress(state)
})

const mapDispatchToProps = (dispatch) => ({})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ technicalCpdProgress }) => ({
      aoaFilter: technicalCpdCategoryFilter,
      heading: `Technical Competence`,
      link: routes.app.training.technicalHome,
      parentCpdCategoryId: fp.get('cpdCategoryId')(technicalCpdProgress.cpdProgress),
      overallCpdProgress: technicalCpdProgress.cpdProgress ? mapTechnicalCpdProgress(technicalCpdProgress) : undefined
    })
  )
)(Home);


// WEBPACK FOOTER //
// ./src/containers/pages/app/training/technical-home.js